module.exports = __webpack_public_path__ + "static/21-8ae9d153f5498a3c01fb577052c2340e.jpg";